module.exports = __webpack_public_path__ + "img/Gray.07615162.png";